export default __webpack_public_path__ + "static/v2_dana_bw-59775c2587099a6fc4c456b634db8b87.jpg";